const langReducer = (lang = "", action) => {
    switch (action.type) {
        case "ADDLang":
          return action.payload

      default:
        return lang;
    }
  };
  export default langReducer;